import styled from "styled-components";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

export const StyledList = styled(List)`
  border-right: 2px solid rgba(155, 155, 155, 0.39);
  min-height: 404px;
  padding: 0px !important;

  @media only screen and (max-width: 1279.95px) {
    min-height: 0px;
    border: none;
    margin-bottom: 30px !important;
  }
`;

export const StyledListItem = styled(ListItem)`
  border-left: 4px solid #ffffff !important;
  padding: 12px 23px !important;
  display: block;
  &.active-link {
    background-color: #f5f5f5 !important;
    border-left: 4px solid #00add2 !important;
  }
  @media only screen and (max-width: 1279.95px) {
    display: inline-block !important;
    width: 49% !important;
    border-left: none !important;
    border-bottom: 4px solid #ffffff !important;

    &.active-link {
      border-left: none !important;
      border-bottom: 4px solid #00add2 !important;
    }
  }
`;

export const StyledListText = styled(ListItemText)`
  span {
    color: rgba(33, 33, 33, 0.87);
    font-family: "Lato";
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    text-decoration: none;
  }
`;
